import { render, staticRenderFns } from "./correctUse.vue?vue&type=template&id=607fa8d0&scoped=true&"
import script from "./correctUse.vue?vue&type=script&lang=js&"
export * from "./correctUse.vue?vue&type=script&lang=js&"
import style0 from "./correctUse.vue?vue&type=style&index=0&id=607fa8d0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fa8d0",
  null
  
)

export default component.exports